module.exports = __webpack_public_path__ + "assets/drop_down_arrow-ede645.svg";